import { Stack, Typography } from '@mui/material';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';

export type ResponseHandler = {
  match: {
    endpointName?: string;
    incentivioCode?: string;
    isRejected?: boolean;
    status?: number;
  };
  then: 'ignore' | ((action: any) => void);
};

export const matchResponse = (
  action: any,
  responseHandlerList: ResponseHandler[],
): ResponseHandler | undefined => {
  const endpointName = action?.meta?.arg?.endpointName;
  const headers = action?.meta?.baseQueryMeta?.response?.headers;
  const incentivioCode = headers?.get('incentivio-code');
  const status = action?.meta?.baseQueryMeta?.response?.status;
  const isRejected = !!isRejectedWithValue(action);

  return responseHandlerList.find(
    responseHandler =>
      (responseHandler.match.endpointName
        ? responseHandler.match.endpointName === endpointName
        : true) &&
      (responseHandler.match.incentivioCode
        ? responseHandler.match.incentivioCode === incentivioCode
        : true) &&
      (responseHandler.match.isRejected !== undefined
        ? responseHandler.match.isRejected === isRejected
        : true) &&
      (responseHandler.match.status
        ? responseHandler.match.status === status
        : true),
  );
};

export const handleDisplayError = action => {
  const headers = action.meta.baseQueryMeta?.response?.headers;
  const code = headers?.get('incentivio-code');
  const message = headers?.get('incentivio-message');

  if (code || message)
    enqueueSnackbar(<ApiErrorToast code={code} message={message} />, {
      severity: 'error',
    });
};

export const ApiErrorToast = ({ code, message }) => (
  <Stack spacing={2} justifyContent="space-between">
    {message && <Typography>{message}</Typography>}
    {code && <Typography variant="caption">{code}</Typography>}
  </Stack>
);
